import { Component, OnInit,HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { chartdata }  from '../class/chatdata';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";
import { ActivatedRoute, DefaultUrlSerializer } from '@angular/router';
import { menulist }  from '../class/status';
import { page }  from '../class/status';

@Component({
    selector: 'app-statistices',
    templateUrl: './statistices.component.html',
    styleUrls: ['./statistices.component.css']
})
export class StatisticesComponent implements OnInit {
    startDate = new Date(1990, 0, 1);
    Highcharts: typeof Highcharts = Highcharts;
    lineOptions: Options = chartdata.staticline;
    lineOptions2: Options = chartdata.line;
    linetext = '';
    lineserze :any=[];

    openMonthdata = false;
    updateFlag:boolean=false;
    os_info:any=[];
    time :any={};
    time_info:any=-1;
    time2 :any={};
    dragIndex:number=-1;
    local_config :any=[];
    local_filter :string='-1';
    local_filtera :any=[];
    data :any=[];
    datav2 :any=[];
    configName :any=[];
    getchart_range_info :any=[];
    chartData :any=[];
    loading:boolean=true;
    barOptions2: Options = JSON.parse(JSON.stringify(chartdata.single_bar));
    // barOptions: Options = JSON.parse(JSON.stringify(chartdata.single_bar));

    previousSelection: string[] = [];
    
    nameArray: string[] = [];
    
    edit_data = [];
    monthRange = '';
    data_view_list_act = '1';
    data_view_list:menulist=[
        {id:'1',name:'以日檢視'},
        {id:'2',name:'以月檢視'},
      ];

    tcontent = [
        {title:'日期',content:'target_date'},
    ];
    
    titleTableName = [{name:'分類'}];
    
    titleTableContent = [];
    groupName = [];
    pageobj:page = {page:0,count:5,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))

    
    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '過去一個月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    }
    @HostListener('window:scroll', ['$event']) onScrollEvent($event){
      if(this.getYPosition($event) > 800)
        this.showbacktop = true;
      else
        this.showbacktop = false;
    }
    showbacktop: boolean = false;

    constructor(
        public httpClient: HttpClient,
        private  route: ActivatedRoute,
    ){}
    logRange(event) {
        this.monthRange = event;
    };

    disable(){
        this.pageobj= {page:0,count:5,total_count:0};
    }

    openMonth(){
        this.pageobj= {page:0,count:5,total_count:0};
        this.openMonthdata = true;
    }

    closeMonth(){
        this.openMonthdata = false;
        this.init_list();
    }

    getNowMonthRange(){
        // 获取当前日期
        var currentDate = new Date();

        // 获取当前月份的年份和月份
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth() + 1; // 注意月份是从0开始计数的，所以要加1

        // 计算上个月的年份和月份
        var lastMonthYear = currentMonth === 1 ? currentYear - 1 : currentYear;
        var lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;

        // 格式化日期字符串
        function formatMonth(year, month) {
            return year + '-' + (month < 10 ? '0' : '') + month;
        }

        // 获取上个月和这个月的月份范围
        var lastMonthRange = formatMonth(lastMonthYear, lastMonth) + '月 - ' + formatMonth(currentYear, currentMonth) + '月';

        this.monthRange = lastMonthRange;
    }

    ngOnInit(): void {

        if(this.route.snapshot.paramMap.get('timeinfo')){
            this.time_info = this.route.snapshot.paramMap.get('timeinfo');
        }

        this.getNowMonthRange();     

        this.init_time();
    }
  

    init_time(){
        this.time.minDate = moment().subtract(180, 'days')
        this.time.maxDate = moment().subtract(0, 'days')
        this.time2.minDate = moment().subtract(180, 'days')
        this.time2.maxDate = moment().subtract(0, 'days')

        let default_status = true;
        if(this.time_info!=-1){
            const tmp = this.time_info.split("_");
            if(tmp.length==4){
                default_status = false;
                this.time.start = tmp[0]
                this.time.end = tmp[1]
                this.time2.start =tmp[2];
                this.time2.end =tmp[3];
                
                this.time.startDate = moment(tmp[0]);
                this.time.endDate = moment(tmp[1]);
                this.time2.startDate = moment(tmp[2]);
                this.time2.endDate = moment(tmp[3]);
            }
        }

        if(default_status){
            this.time.startDate = moment().subtract(7, 'days');
            this.time.endDate = moment().subtract(0, 'days');
            this.time.start = moment(this.time.startDate)
            this.time.end = moment(this.time.endDate)

            this.time2.startDate = moment().subtract(14, 'days');
            this.time2.endDate = moment().subtract(7, 'days');
            this.time2.start = moment(this.time2.startDate)
            this.time2.end = moment(this.time2.endDate)
        }

        this.init_list();  
    }

    callback(pageobj:page){        
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
          this.pageobj = pageobj;
          this.init_list();
        }
    }


    init_list(){
        this.loading = true;
        const body = {now_range:this.time,past_range:this.time2,page: this.pageobj.page,count:this.pageobj.count,dataact:this.data_view_list_act,month:this.monthRange};
        this.httpClient.post<any>("/get_range_info_v2.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.datav2 = res.datav2;
                this.pageobj.total_count = res.total_count
                this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
                this.configName = res.configName;
            }else{
                this.data = [];
            }
            this.get_local_config();
            this.get_select_config();

            this.titleTableContent = [];
            this.groupName= [];
            this.tcontent =[
                {title:'日期',content:'target_date'},
            ];

            this.get_title_contentv2();
            this.BtnSort();

        });
    }

    get_title_contentv2(){ 
   
        if(this.configName.length > 0){
            this.configName.forEach((v,k) => {
                
                let groupName_tmp = {name:Object.keys(v)[0].replace(/\s/g, "")};
                this.groupName.push(groupName_tmp);

                if(this.local_config.indexOf(Object.keys(v)[0])!=-1){

                    let arr = Object.values(v)[0];

                    if (Array.isArray(arr)) {

                        let titleTableContent_tmp = {name:Object.keys(v)[0].replace(/\s/g, "") ,colspan:arr.length};
                        
                        this.titleTableContent.push(titleTableContent_tmp);
                    
                        arr.forEach((vs, ks) => {
                            let tcontent_tmp = {title:vs.chinese_name.replace(/\s/g, "") ,content:vs.key_name.replace(/\s/g, ""),type:3};
                            this.tcontent.push(tcontent_tmp);
                        });
                    } 
                }
            });
        }

    }


    get_select_config(){
        this.local_filtera = this.local_config;
        this.previousSelection = this.local_config;
    }

  
    get_local_config(){
        const tmp_str = localStorage.getItem('statistics_config');
        const default_filter_list = this.data.map(item => item.name);
        if(tmp_str){
            try {
                this.local_config = JSON.parse(tmp_str);
            }catch{
                this.local_config = default_filter_list;
            }
        }
        if(!tmp_str || this.local_config.length == 0){
            this.local_config = default_filter_list;
        }
        this.fresh_local_config();
    }

    fresh_show_dataArray(nameArray: string[]): void {
        // 處理陣列的初始化（可能在構造函數中）
        if (!this.nameArray.length) {
            this.nameArray = nameArray;
        }
    
        let lastSelectedValue = this.getArrayDifference(nameArray, this.previousSelection);
    
        if (lastSelectedValue.length === 0) {
            lastSelectedValue = this.getArrayDifference(this.previousSelection, nameArray);
        }
    
        if (lastSelectedValue.length === 0) {
            this.handleNoSelection();
        } else {
            const name = lastSelectedValue[0];
            this.updateLocalConfig(name);
        }
    
        this.previousSelection = this.local_config;

        this.titleTableContent = [];
        this.groupName= [];
        this.tcontent =[
            {title:'日期',content:'target_date'},
        ];

        this.get_title_contentv2();
        this.BtnSort();
    }
    
    getArrayDifference(arrayA: string[], arrayB: string[]): string[] {
        return Array.from(new Set(arrayA.filter(value => !arrayB.includes(value))));
    }
    
    handleNoSelection(): void {
        this.local_filtera = this.local_config;
        alert('至少要有一個類別');
    }
    
    updateLocalConfig(name: string): void {
        const index = this.local_config.indexOf(name);
    
        if (index === -1) {
            this.local_config.push(name);
            this.fresh_local_config();
        } else {
            this.handleConfigRemoval(index);
        }
    }
    
    handleConfigRemoval(index: number): void {
        if (this.local_config.length === 1) {
            this.handleNoSelection();
        } else {
            this.local_config.splice(index, 1);
            this.fresh_local_config();
        }
    }

    
    fresh_show_data(name){

        const index = this.local_config.findIndex((v)=>{
            return name == v;
        })

        if(index==-1){
            this.local_config.push(name);
            this.fresh_local_config();
        }else{
            if( this.local_config.length==1){
                alert('至少要有一個類別');
            }else{
                this.local_config.splice(index,1)
                this.fresh_local_config();
            }
        } 


        this.BtnSort();

        this.titleTableContent = [];
        this.groupName= [];
        this.tcontent =[
            {title:'日期',content:'target_date'},
        ];
        
        this.get_title_contentv2();
  
    }

    BtnSort(){

        const tmp = [];
        this.groupName.forEach(v => {
            const index = this.local_config.findIndex((vs)=>{
                return v.name == vs;
            })
        
            if(index!=-1){
                tmp.push(v.name);
            }
        });

        this.local_config = tmp;
        this.local_filtera = tmp;


    }


    fresh_local_config(){
        this.data = this.data.sort((a, b) => {
            const indexA = this.local_config.indexOf(a.name);
            const indexB = this.local_config.indexOf(b.name);
            return indexA - indexB;
        });
        localStorage.setItem('statistics_config',JSON.stringify(this.local_config));
    }

    onDateTyped(event: any) {
        const val = (event && event.target && event.target.value) ? String(event.target.value) : '';
        if (!val) { return; }
        const parts = val.split(' - ');
        if (parts.length !== 2) { return; }
        let s = moment(parts[0].trim(), 'YYYY-MM-DD', true);
        let e = moment(parts[1].trim(), 'YYYY-MM-DD', true);
        if (!s.isValid() || !e.isValid()) { return; }
        if (s.isAfter(e)) { const t = s; s = e; e = t; }
        // 冪等：與目前範圍相同就不重複觸發（避免點選後 blur 又重查一次）
        if (this.time && this.time.start === s.format('YYYY-MM-DD') && this.time.end === e.format('YYYY-MM-DD')) { return; }
        this.onRangeSelected(1, { startDate: s, endDate: e });
    }

    onRangeSelected(type,value: any) {
        this.pageobj= {page:0,count:5,total_count:0};
        if(value.startDate){
            if(type==1){
                this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
                this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
            }else{
                this.time2.start =  moment(value.startDate).format('YYYY-MM-DD')
                this.time2.end =  moment(value.endDate).format('YYYY-MM-DD')
            }
            this.init_list();  
        }

        this.chartpic();
    }

    chartpic(){
        let stime = moment(this.time.start).format('YYYY-MM-DD');
        let etime = moment(this.time.end).format('YYYY-MM-DD');

        const startDate = moment(stime);
        const endDate = moment(etime);
        const dates = [];

        while (startDate.isSameOrBefore(endDate)) {
            dates.push(startDate.format('YYYY-MM-DD'));
            startDate.add(1, 'day');
        }

        let chartcategories = dates;
        this.lineOptions.xAxis = {categories: chartcategories};

    }

    onDragOver(event,index) {
        event.preventDefault();
        if (this.dragIndex !== index) {
            const source = this.local_config[this.dragIndex];
            const target = this.local_config[index];
            this.local_config.splice(this.dragIndex, 1);
            this.local_config.splice(index, 0, source);
            this.dragIndex = index;
        }
    }

    onDragLeave(event,index) {
        this.fresh_local_config();
    }

 
    go_top(){
        var btn_click = document.getElementById("go_top");
        const tmp = this.getOffset(btn_click);
    	this.scrollAnimation(tmp.top,0);
    }

    getOffset (el) {
        const box = el.getBoundingClientRect();
        return{
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        }
    }

    scrollAnimation(currentY, targetY) {
        let needScrollTop = targetY - currentY
        let _currentY = currentY
        setTimeout(() => {
            const dist = Math.ceil(needScrollTop / 10)
            _currentY += dist
            window.scrollTo(_currentY, currentY)
            if (needScrollTop > 10 || needScrollTop < -10) {
                this.scrollAnimation(_currentY, targetY)
            } else {
                window.scrollTo(_currentY, targetY)
            }
        }, 10)
    }

    getYPosition(e: Event): number {
        return (e.target as Element)['scrollingElement'].scrollTop;
    }
}
